import {  SettingsNotification } from '../Types/Notifications.types';
import { fetchNotificationsByJobid, setNewNotification } from '../Slices/Notifications.slice';
import { AppDispatch } from '../../app/store';

export function addSettingsSuccessNotification(settingsSuccessMessage: SettingsNotification, dispatch: AppDispatch) {
	dispatch(fetchNotificationsByJobid(settingsSuccessMessage.groupId));
	dispatch(setNewNotification());
}

export function addSettingsFailureNotification(settingsFailedMessage: SettingsNotification, dispatch: AppDispatch) {
	dispatch(fetchNotificationsByJobid(settingsFailedMessage.groupId));
	dispatch(setNewNotification());
}
